export const START_CALL = "START_CALL";
export const UPDATE_STATECALL = "UPDATE_STATECALL";
export const UPDATE_STATECALL_RECEIVED_DATE = "UPDATE_STATECALL_RECEIVED_DATE";
export const UPDATE_CALL_STATE = "UPDATE_CALL_STATE";
export const TOGGLE_HOLD = "TOGGLE_HOLD";
export const TOGGLE_MUTE = "TOGGLE_MUTE";
export const START_ACW = "START_ACW";
export const RESET_CALL_STATE = "RESET_CALL_STATE";
export const INCOMING_CALL = "INCOMING_CALL";
export const WAITING_CALL = "WAITING_CALL";
export const SET_GO_TO_ACW = "SET_GO_TO_ACW";
export const SHOW_CONTACT_MODAL = "SHOW_CONTACT_MODAL";
export const SET_IS_CONSULTING = "SET_IS_CONSULTING";
export const SET_IS_PARKING = "SET_IS_PARKING";
export const SET_NEXT_ASSIGNMENT = "SET_NEXT_ASSIGNMENT";
export const SET_SELECTED_CALL_RECORD_ID = "SET_SELECTED_CALL_RECORD_ID";
export const SET_IN_APP_CALL_STATUS = "SET_IN_APP_CALL_STATUS";
export const SET_IN_APP_CALL_TYPE = "SET_IN_APP_CALL_TYPE";
export const CHECK_STRAY_CALL = "CHECK_STRAY_CALL";
export const SET_IS_IN_CALL = "SET_IS_IN_CALL";
export const END_ACW = "END_ACW";
export const SET_SCREEN_REC_FILENAME = "SET_SCREEN_REC_FILENAME";
export const SET_IS_CONTINUE_TRANSFER = "SET_IS_CONTINUE_TRANSFER";
export const SET_TRANSFER_COUNT = "SET_TRANSFER_COUNT";
